var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "myToDo" },
    [
      _c(
        "el-tabs",
        {
          attrs: { value: _vm.tabActiveName },
          on: { "tab-click": _vm.handleTabClick },
        },
        [
          _vm.$hasBtnRoles("/user/project-delivery/my-to-do-project")
            ? _c("el-tab-pane", { attrs: { label: "项目列表", name: "1" } }, [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _c(
                      "el-badge",
                      {
                        attrs: {
                          value: _vm.toDoProjectCount,
                          max: 99,
                          hidden: _vm.toDoProjectCount === 0,
                        },
                      },
                      [_vm._v(" 项目列表 ")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.$hasBtnRoles("/user/project-delivery/my-to-do-mall")
            ? _c("el-tab-pane", { attrs: { label: "商城装修", name: "2" } }, [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _c(
                      "el-badge",
                      {
                        attrs: {
                          value: _vm.toDoMallCount,
                          max: 99,
                          hidden: _vm.toDoMallCount === 0,
                        },
                      },
                      [_vm._v(" 商城装修 ")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.$hasBtnRoles("/user/project-delivery/my-to-do-bidding")
            ? _c("el-tab-pane", { attrs: { label: "投标支持", name: "3" } }, [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _c(
                      "el-badge",
                      {
                        attrs: {
                          value: _vm.toDoBiddingCount,
                          max: 99,
                          hidden: _vm.toDoBiddingCount === 0,
                        },
                      },
                      [_vm._v(" 投标支持 ")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.$hasBtnRoles("/user/project-delivery/my-to-do-printing")
            ? _c(
                "el-tab-pane",
                { attrs: { label: "定制设计工单", name: "4" } },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c(
                        "el-badge",
                        {
                          attrs: {
                            value: _vm.toDoPrintingCount,
                            max: 99,
                            hidden: _vm.toDoPrintingCount === 0,
                          },
                        },
                        [_vm._v(" 定制设计工单 ")]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm.$hasBtnRoles("/user/project-ticket/my-to-do")
            ? _c("el-tab-pane", { attrs: { label: "咨询工单", name: "5" } }, [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _c(
                      "el-badge",
                      {
                        attrs: {
                          value: _vm.toDoTicketCount,
                          max: 99,
                          hidden: _vm.toDoTicketCount === 0,
                        },
                      },
                      [_vm._v(" 咨询工单 ")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.$hasBtnRoles("/user/project-delivery/my-to-do-quotation")
            ? _c("el-tab-pane", { attrs: { label: "报价单配置", name: "6" } }, [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _c(
                      "el-badge",
                      {
                        attrs: {
                          value: _vm.toDoQuotationCount,
                          max: 99,
                          hidden: _vm.toDoQuotationCount === 0,
                        },
                      },
                      [_vm._v(" 报价单配置 ")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !["5", "6"].includes(_vm.tabActiveName),
              expression: "!['5', '6'].includes(tabActiveName)",
            },
          ],
          ref: "searchForm",
          attrs: { id: "searchDom", inline: "" },
        },
        [
          _c(
            "el-form-item",
            { key: "f1", attrs: { label: "项目ID" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入项目ID" },
                model: {
                  value: _vm.searchForm.number,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "number", $$v)
                  },
                  expression: "searchForm.number",
                },
              }),
            ],
            1
          ),
          _vm.tabActiveName != "1"
            ? _c(
                "el-form-item",
                { key: "f2", attrs: { label: "任务ID" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入任务ID" },
                    model: {
                      value: _vm.searchForm.item_number,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "item_number", $$v)
                      },
                      expression: "searchForm.item_number",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "1"
            ? _c(
                "el-form-item",
                { key: "f3", attrs: { label: "项目状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "项目待过会", value: 100 },
                      }),
                      _c("el-option", {
                        attrs: { label: "处理中", value: 200 },
                      }),
                      _c("el-option", {
                        attrs: { label: "部分完成", value: 399 },
                      }),
                      _c("el-option", {
                        attrs: { label: "已完成", value: 400 },
                      }),
                      _c("el-option", { attrs: { label: "弃标", value: 700 } }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "2"
            ? _c(
                "el-form-item",
                { key: "f4", attrs: { label: "任务状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "处理中", value: 100 },
                      }),
                      _c("el-option", {
                        attrs: { label: "待验收", value: 200 },
                      }),
                      _c("el-option", {
                        attrs: { label: "已完成", value: 300 },
                      }),
                      _c("el-option", {
                        attrs: { label: "已终止", value: 700 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "3"
            ? _c(
                "el-form-item",
                { key: "f5", attrs: { label: "任务状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "标书处理中", value: 100 },
                      }),
                      _c("el-option", {
                        attrs: { label: "标书已完成待开标", value: 300 },
                      }),
                      _c("el-option", {
                        attrs: { label: "已开标未出结果", value: 450 },
                      }),
                      _c("el-option", {
                        attrs: { label: "未中标", value: 500 },
                      }),
                      _c("el-option", {
                        attrs: { label: "中标未交付", value: 550 },
                      }),
                      _c("el-option", {
                        attrs: { label: "中标已交付", value: 600 },
                      }),
                      _c("el-option", {
                        attrs: { label: "已终止", value: 700 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "4"
            ? _c(
                "el-form-item",
                { key: "f6", attrs: { label: "任务状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "处理中", value: 100 },
                      }),
                      _c("el-option", {
                        attrs: { label: "设计完成待确认", value: 201 },
                      }),
                      _c("el-option", {
                        attrs: { label: "已完成", value: 300 },
                      }),
                      _c("el-option", {
                        attrs: { label: "已终止", value: 700 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "4"
            ? _c(
                "el-form-item",
                { key: "f7", attrs: { label: "印刷单" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.searchForm.need_printing,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "need_printing", $$v)
                        },
                        expression: "searchForm.need_printing",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "需要印刷", value: 1 },
                      }),
                      _c("el-option", {
                        attrs: { label: "不需要印刷", value: 2 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "4"
            ? _c(
                "el-form-item",
                { key: "f8", attrs: { label: "加急设计" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.searchForm.expedited_not,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "expedited_not", $$v)
                        },
                        expression: "searchForm.expedited_not",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "需要", value: 2 } }),
                      _c("el-option", { attrs: { label: "不需要", value: 1 } }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "4"
            ? _c(
                "el-form-item",
                { key: "f9", attrs: { label: "加急印刷" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.searchForm.urgent_printing,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "urgent_printing", $$v)
                        },
                        expression: "searchForm.urgent_printing",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "需要", value: 2 } }),
                      _c("el-option", { attrs: { label: "不需要", value: 1 } }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { key: "f10", attrs: { label: "客户名称" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: {
                    remote: "",
                    "remote-method": _vm.getCompanyList,
                    clearable: "",
                    filterable: "",
                    placeholder: "请输入公司名称",
                  },
                  model: {
                    value: _vm.searchForm.customer_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "customer_id", $$v)
                    },
                    expression: "searchForm.customer_id",
                  },
                },
                _vm._l(_vm.companyList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.company_name + "（" + item.id + "）",
                      value: item.id,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { key: "f11", attrs: { label: "项目名称" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入项目名称" },
                model: {
                  value: _vm.searchForm.project_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "project_name", $$v)
                  },
                  expression: "searchForm.project_name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { key: "f12", attrs: { label: "项目类型" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "230px" },
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    clearable: "",
                    placeholder: "请选择",
                  },
                  model: {
                    value: _vm.searchForm.project_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "project_type", $$v)
                    },
                    expression: "searchForm.project_type",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "个性化项目评估（启动会）", value: 1 },
                  }),
                  _c("el-option", {
                    attrs: { label: "其他个性化需求", value: 2 },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.tabActiveName == "1"
            ? _c(
                "el-form-item",
                { key: "f13", attrs: { label: "任务" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.searchForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "type", $$v)
                        },
                        expression: "searchForm.type",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "商城装修", value: 1 },
                      }),
                      _c("el-option", {
                        attrs: { label: "投标支持", value: 2 },
                      }),
                      _c("el-option", {
                        attrs: { label: "定制设计印刷", value: 3 },
                      }),
                      _c("el-option", { attrs: { label: "报价单", value: 9 } }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "1"
            ? _c(
                "el-form-item",
                { key: "f23", attrs: { label: "提交时间" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "230px" },
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "value-format": "yyyy-MM-dd",
                      format: "yyyy-MM-dd",
                    },
                    on: { change: _vm.changeProjectCreatedTime },
                    model: {
                      value: _vm.projectCreatedAtTime,
                      callback: function ($$v) {
                        _vm.projectCreatedAtTime = $$v
                      },
                      expression: "projectCreatedAtTime",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { key: "f14", attrs: { label: "提交人" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    remote: "",
                    "remote-method": _vm.searchSubmitter,
                    loading: _vm.personLoading,
                    "no-data-text": "无数据",
                    placeholder: "请选择",
                  },
                  on: {
                    clear: function ($event) {
                      return _vm.searchSubmitter("")
                    },
                  },
                  model: {
                    value: _vm.searchForm.user_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "user_id", $$v)
                    },
                    expression: "searchForm.user_id",
                  },
                },
                _vm._l(_vm.personOptions.submitter || [], function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label:
                        item.name +
                        (item.status_cn && item.status_cn !== "在职"
                          ? "（" + item.status_cn + "）"
                          : ""),
                      value: item.id,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm.tabActiveName == "2"
            ? _c(
                "el-form-item",
                { key: "f24", attrs: { label: "提交时间" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "230px" },
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "value-format": "yyyy-MM-dd",
                      format: "yyyy-MM-dd",
                    },
                    on: { change: _vm.changeMallCreatedTime },
                    model: {
                      value: _vm.mallCreatedAtTime,
                      callback: function ($$v) {
                        _vm.mallCreatedAtTime = $$v
                      },
                      expression: "mallCreatedAtTime",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "3"
            ? _c(
                "el-form-item",
                { key: "f25", attrs: { label: "项目负责人" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.searchForm.person_charge_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "person_charge_id", $$v)
                        },
                        expression: "searchForm.person_charge_id",
                      },
                    },
                    _vm._l(_vm.decorationPersonList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "3"
            ? _c(
                "el-form-item",
                { key: "f26", attrs: { label: "上传标书" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.searchForm.bid_files,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "bid_files", $$v)
                        },
                        expression: "searchForm.bid_files",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "已上传", value: 1 } }),
                      _c("el-option", { attrs: { label: "未上传", value: 0 } }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "3"
            ? _c(
                "el-form-item",
                { key: "f27", attrs: { label: "提交时间" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "230px" },
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "value-format": "yyyy-MM-dd",
                      format: "yyyy-MM-dd",
                    },
                    on: { change: _vm.changeBiddingCreatedTime },
                    model: {
                      value: _vm.biddingCreatedAtTime,
                      callback: function ($$v) {
                        _vm.biddingCreatedAtTime = $$v
                      },
                      expression: "biddingCreatedAtTime",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "4"
            ? _c(
                "el-form-item",
                { key: "f15", attrs: { label: "提交时间" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "230px" },
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "value-format": "yyyy-MM-dd",
                      format: "yyyy-MM-dd",
                    },
                    on: { change: _vm.changeCreatedTime },
                    model: {
                      value: _vm.createdAtTime,
                      callback: function ($$v) {
                        _vm.createdAtTime = $$v
                      },
                      expression: "createdAtTime",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "4"
            ? _c(
                "el-form-item",
                { key: "f16", attrs: { label: "处理时间" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "230px" },
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "value-format": "yyyy-MM-dd",
                      format: "yyyy-MM-dd",
                    },
                    on: { change: _vm.changeUpdatedTime },
                    model: {
                      value: _vm.updatedAtTime,
                      callback: function ($$v) {
                        _vm.updatedAtTime = $$v
                      },
                      expression: "updatedAtTime",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "4"
            ? _c(
                "el-form-item",
                { key: "f17", attrs: { label: "创建制卡" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.searchForm.card_make,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "card_make", $$v)
                        },
                        expression: "searchForm.card_make",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "已创建", value: 1 } }),
                      _c("el-option", { attrs: { label: "未创建", value: 2 } }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "4"
            ? _c(
                "el-form-item",
                { key: "f18", attrs: { label: "创建印刷单" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.searchForm.card_make_print,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "card_make_print", $$v)
                        },
                        expression: "searchForm.card_make_print",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "已创建", value: 1 } }),
                      _c("el-option", { attrs: { label: "未创建", value: 2 } }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "4"
            ? _c(
                "el-form-item",
                { key: "f19", attrs: { label: "订单预计金额" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "120px" },
                    attrs: { clearable: "", placeholder: "最小值" },
                    on: {
                      input: function ($event) {
                        _vm.searchForm.estimated_amount_start =
                          _vm.searchForm.estimated_amount_start
                            .replace(/[^\d]/g, "")
                            .replace(/^0+/, "")
                      },
                    },
                    model: {
                      value: _vm.searchForm.estimated_amount_start,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "estimated_amount_start", $$v)
                      },
                      expression: "searchForm.estimated_amount_start",
                    },
                  }),
                  _c("span", { staticStyle: { margin: "0 4px" } }, [
                    _vm._v("-"),
                  ]),
                  _c("el-input", {
                    staticStyle: { width: "120px" },
                    attrs: { clearable: "", placeholder: "最大值" },
                    on: {
                      input: function ($event) {
                        _vm.searchForm.estimated_amount_end =
                          _vm.searchForm.estimated_amount_end
                            .replace(/[^\d]/g, "")
                            .replace(/^0+/, "")
                      },
                    },
                    model: {
                      value: _vm.searchForm.estimated_amount_end,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "estimated_amount_end", $$v)
                      },
                      expression: "searchForm.estimated_amount_end",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "4"
            ? _c(
                "el-form-item",
                { key: "f20", attrs: { label: "设计复杂度" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.searchForm.design_complexity,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "design_complexity", $$v)
                        },
                        expression: "searchForm.design_complexity",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "简单", value: 1 } }),
                      _c("el-option", { attrs: { label: "中级", value: 2 } }),
                      _c("el-option", { attrs: { label: "复杂", value: 3 } }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { key: "f21" },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.resetList },
                },
                [_vm._v("搜 索")]
              ),
            ],
            1
          ),
          _vm.tabActiveName == "4"
            ? _c(
                "el-form-item",
                { key: "f22" },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.exportPrinting },
                    },
                    [_vm._v("导 出")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tabActiveName == "5",
              expression: "tabActiveName == '5'",
            },
          ],
          ref: "ticketSearchForm",
          attrs: { id: "ticketSearchDom", inline: "" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "工单编号" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入工单编号" },
                model: {
                  value: _vm.ticketSearchForm.work_order_no,
                  callback: function ($$v) {
                    _vm.$set(_vm.ticketSearchForm, "work_order_no", $$v)
                  },
                  expression: "ticketSearchForm.work_order_no",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "工单标题" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入工单标题" },
                model: {
                  value: _vm.ticketSearchForm.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.ticketSearchForm, "title", $$v)
                  },
                  expression: "ticketSearchForm.title",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "咨询事项" } },
            [
              _c("el-cascader", {
                staticStyle: { width: "230px" },
                attrs: {
                  options: _vm.ticketCategoryTree,
                  props: {
                    multiple: true,
                    label: "name",
                    value: "id",
                    children: "children",
                  },
                  "collapse-tags": "",
                  clearable: "",
                  filterable: "",
                  placeholder: "请选择",
                },
                model: {
                  value: _vm.ticketSearchForm.second_category_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.ticketSearchForm, "second_category_id", $$v)
                  },
                  expression: "ticketSearchForm.second_category_id",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "具体事项" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入具体事项" },
                model: {
                  value: _vm.ticketSearchForm.item,
                  callback: function ($$v) {
                    _vm.$set(_vm.ticketSearchForm, "item", $$v)
                  },
                  expression: "ticketSearchForm.item",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "工单状态" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    clearable: "",
                    placeholder: "请选择",
                  },
                  model: {
                    value: _vm.ticketSearchForm.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.ticketSearchForm, "status", $$v)
                    },
                    expression: "ticketSearchForm.status",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "处理中", value: 20 } }),
                  _c("el-option", { attrs: { label: "已解决", value: 30 } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "提交时间" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "230px" },
                attrs: {
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "value-format": "yyyy-MM-dd",
                  format: "yyyy-MM-dd",
                },
                on: { change: _vm.changeTicketCreatedAtTime },
                model: {
                  value: _vm.ticketCreatedAtTime,
                  callback: function ($$v) {
                    _vm.ticketCreatedAtTime = $$v
                  },
                  expression: "ticketCreatedAtTime",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.ticketResetList },
                },
                [_vm._v("搜 索")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !["5", "6"].includes(_vm.tabActiveName),
              expression: "!['5', '6'].includes(tabActiveName)",
            },
          ],
          attrs: {
            border: "",
            "header-cell-style": { background: "#f1f1f1", color: "#333333" },
            align: "center",
            data: _vm.listData,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label:
                _vm.tabActiveName == "1"
                  ? "项目ID/项目状态"
                  : "任务ID/项目状态",
              width: "140",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.number))]),
                    _c("div", [_vm._v(_vm._s(scope.row.status_cn))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "客户名称/项目名称" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(scope.row.customer_name) +
                          "(" +
                          _vm._s(scope.row.customer_id) +
                          ")"
                      ),
                    ]),
                    _c("div", [_vm._v(_vm._s(scope.row.project_name))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "项目类型/任务", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.project_type_cn))]),
                    _vm._l(scope.row.type_of_demand, function (value, index) {
                      return _c("div", { key: index }, [
                        _c("span", [_vm._v(_vm._s(value.type_cn))]),
                        _c(
                          "span",
                          {
                            style: {
                              display:
                                _vm.tabActiveName == "3" ||
                                _vm.tabActiveName == "4"
                                  ? "block"
                                  : "inline",
                            },
                          },
                          [
                            _vm.tabActiveName != "3" && _vm.tabActiveName != "4"
                              ? [_vm._v("（")]
                              : _vm._e(),
                            _c(
                              "span",
                              {
                                style: {
                                  color:
                                    {
                                      1: "#409EFF",
                                      50: "#E6A23C",
                                      100: "#F56C6C",
                                      200: "#409EFF",
                                      201: "#409EFF",
                                      300: "#909399",
                                      400: "#F56C6C",
                                      700: "#909399",
                                      800: "#909399",
                                    }[value.status] || "#409EFF",
                                  cursor:
                                    _vm.tabActiveName != "1" &&
                                    (value.type == 2 || value.type == 3)
                                      ? "pointer"
                                      : "default",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.tabActiveName != "1" &&
                                      _vm.handleDemandStatusClick(
                                        scope.row,
                                        value
                                      )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    {
                                      1: "待审批",
                                      50: "待分配",
                                      100:
                                        value.type == 2
                                          ? "标书处理中"
                                          : "处理中",
                                      200: "待验收",
                                      201: "设计完成待确认",
                                      300:
                                        value.type == 2
                                          ? "标书已完成待开标"
                                          : "已完成",
                                      400: "审批驳回",
                                      450: "已开标未出结果",
                                      500: "未中标",
                                      550: "中标未交付",
                                      600: "中标已交付",
                                      700: "已终止",
                                      800: "已失效",
                                    }[value.status]
                                  )
                                ),
                              ]
                            ),
                            _vm.tabActiveName != "3" && _vm.tabActiveName != "4"
                              ? [_vm._v("）")]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ])
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm.tabActiveName == "4"
            ? _c("el-table-column", {
                attrs: { label: "印刷单", width: "110" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return _vm._l(
                          _vm.getPrintingSheetValues(scope.row),
                          function (value, index) {
                            return _c("div", { key: index }, [
                              value.type
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "printing-sheet-link",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handlePrintingSheetClick(
                                            scope.row,
                                            value.type
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(_vm._s(value.label)),
                                      _c(
                                        "span",
                                        { staticClass: "printing-sheet-value" },
                                        [_vm._v(_vm._s(value.value))]
                                      ),
                                    ]
                                  )
                                : _c("span", [_vm._v(_vm._s(value.text))]),
                            ])
                          }
                        )
                      },
                    },
                  ],
                  null,
                  false,
                  3873171118
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { label: "负责人", prop: "head", width: "110" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(scope.row.head, function (value, index) {
                    return _c("div", { key: index }, [
                      _vm._v(" " + _vm._s(value) + " "),
                    ])
                  })
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "提交人/提交时间", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.create_name))]),
                    _c("div", [_vm._v(_vm._s(scope.row.user_organize_name))]),
                    _c("div", [_vm._v(_vm._s(scope.row.created_at))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "处理人/处理时间", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.tabActiveName != "1"
                      ? [
                          _c("div", [
                            _vm._v(_vm._s(scope.row.task_handler_name)),
                          ]),
                          _c("div", [
                            _vm._v(_vm._s(scope.row.task_handler_time)),
                          ]),
                        ]
                      : [
                          _c("div", [_vm._v(_vm._s(scope.row.handler_name))]),
                          scope.row.create_name
                            ? _c("div", [_vm._v(_vm._s(scope.row.updated_at))])
                            : _vm._e(),
                        ],
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "跟进记录", prop: "operation" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.operation && scope.row.operation.length > 9
                      ? _c(
                          "el-tooltip",
                          {
                            staticClass: "tipBox",
                            attrs: {
                              "popper-class": "popperTipBox",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              _vm._l(
                                scope.row.operation,
                                function (value, index) {
                                  return _c("div", { key: index }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(value.created_at) +
                                        " " +
                                        _vm._s(value.operation_id) +
                                        " " +
                                        _vm._s(value.content) +
                                        " "
                                    ),
                                  ])
                                }
                              ),
                              0
                            ),
                            _vm._l(
                              scope.row.operation,
                              function (value, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    class: _vm.getFollowUpItemClass(index),
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(value.created_at) +
                                        " " +
                                        _vm._s(value.operation_id) +
                                        " " +
                                        _vm._s(value.content) +
                                        " "
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        )
                      : _c(
                          "div",
                          _vm._l(scope.row.operation, function (value, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                class: _vm.getFollowUpItemClass(index),
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(value.created_at) +
                                    " " +
                                    _vm._s(value.operation_id) +
                                    " " +
                                    _vm._s(value.content) +
                                    " "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.viewDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    _vm.tabActiveName == "1" &&
                    [200, 399].includes(Number(scope.row.status)) &&
                    scope.row.project_type != 2
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleProjectProcess(scope.row)
                              },
                            },
                          },
                          [_vm._v("处理")]
                        )
                      : _vm._e(),
                    _vm.tabActiveName == "2" &&
                    (scope.row.type_of_demand || []).some(function (item) {
                      return item.status == 100
                    })
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleProcess(scope.row)
                              },
                            },
                          },
                          [_vm._v("处理")]
                        )
                      : _vm._e(),
                    _vm.tabActiveName == "3" &&
                    (scope.row.type_of_demand || []).some(function (item) {
                      return item.status == 100
                    })
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleBiddingProcess(scope.row)
                              },
                            },
                          },
                          [_vm._v("上传标书")]
                        )
                      : _vm._e(),
                    _vm.tabActiveName == "3" &&
                    (scope.row.type_of_demand || []).some(function (item) {
                      return item.status == 450
                    })
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleBiddingResultClick(scope.row)
                              },
                            },
                          },
                          [_vm._v("上传结果")]
                        )
                      : _vm._e(),
                    _vm.tabActiveName == "3" &&
                    (scope.row.type_of_demand || []).some(function (item) {
                      return item.status == 550
                    })
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleBiddingDeliveryClick(scope.row)
                              },
                            },
                          },
                          [_vm._v("项目交付")]
                        )
                      : _vm._e(),
                    _vm.tabActiveName == "4" &&
                    (scope.row.type_of_demand || []).some(function (item) {
                      return item.status == 100
                    })
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleCardAndCouponDesignProcess(
                                  scope.row
                                )
                              },
                            },
                          },
                          [_vm._v("处理")]
                        )
                      : _vm._e(),
                    _vm.tabActiveName == "1" && scope.row.status == 100
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleProjectReview(scope.row)
                              },
                            },
                          },
                          [_vm._v("项目待过会")]
                        )
                      : _vm._e(),
                    _vm.$hasBtnRoles("/user/project-delivery/follow-up")
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openFollowUp(scope.row)
                              },
                            },
                          },
                          [_vm._v("跟进")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !["5", "6"].includes(_vm.tabActiveName),
              expression: "!['5', '6'].includes(tabActiveName)",
            },
          ],
          staticClass: "pages",
          staticStyle: { "text-align": "right", margin: "16px 0" },
        },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.listPages.currentPage,
              "page-size": _vm.searchForm.pageSize,
              "page-sizes": [20, 50, 100, 200, 500],
              total: _vm.listPages.totalCount,
              layout: "total,sizes, prev, pager, next, jumper",
            },
            on: {
              "current-change": _vm.handlePageChange,
              "size-change": _vm.sizeChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tabActiveName == "6",
              expression: "tabActiveName == '6'",
            },
          ],
          ref: "quotationSearchForm",
          attrs: { id: "quotationSearchDom", inline: "" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "项目ID" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入项目ID" },
                model: {
                  value: _vm.quotationSearchForm.number,
                  callback: function ($$v) {
                    _vm.$set(_vm.quotationSearchForm, "number", $$v)
                  },
                  expression: "quotationSearchForm.number",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "任务ID" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入任务ID" },
                model: {
                  value: _vm.quotationSearchForm.item_number,
                  callback: function ($$v) {
                    _vm.$set(_vm.quotationSearchForm, "item_number", $$v)
                  },
                  expression: "quotationSearchForm.item_number",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "报价单状态" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    clearable: "",
                    placeholder: "请选择",
                  },
                  model: {
                    value: _vm.quotationSearchForm.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.quotationSearchForm, "status", $$v)
                    },
                    expression: "quotationSearchForm.status",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "处理中", value: 100 } }),
                  _c("el-option", { attrs: { label: "已完成", value: 300 } }),
                  _c("el-option", { attrs: { label: "已失效", value: 800 } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "客户名称" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: {
                    remote: "",
                    "remote-method": _vm.getCompanyList,
                    clearable: "",
                    filterable: "",
                    placeholder: "请输入公司名称",
                  },
                  model: {
                    value: _vm.quotationSearchForm.customer_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.quotationSearchForm, "customer_id", $$v)
                    },
                    expression: "quotationSearchForm.customer_id",
                  },
                },
                _vm._l(_vm.companyList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.company_name + "（" + item.id + "）",
                      value: item.id,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "项目名称" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入项目名称" },
                model: {
                  value: _vm.quotationSearchForm.project_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.quotationSearchForm, "project_name", $$v)
                  },
                  expression: "quotationSearchForm.project_name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "项目类型" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "230px" },
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    clearable: "",
                    placeholder: "请选择",
                  },
                  model: {
                    value: _vm.quotationSearchForm.project_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.quotationSearchForm, "project_type", $$v)
                    },
                    expression: "quotationSearchForm.project_type",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "个性化项目评估（启动会）", value: 1 },
                  }),
                  _c("el-option", {
                    attrs: { label: "其他个性化需求", value: 2 },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "提交人" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    remote: "",
                    "remote-method": _vm.searchQuotationSubmitter,
                    loading: _vm.personLoading,
                    "no-data-text": "无数据",
                    placeholder: "请选择",
                  },
                  on: {
                    clear: function ($event) {
                      return _vm.searchQuotationSubmitter("")
                    },
                  },
                  model: {
                    value: _vm.quotationSearchForm.user_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.quotationSearchForm, "user_id", $$v)
                    },
                    expression: "quotationSearchForm.user_id",
                  },
                },
                _vm._l(
                  _vm.personOptions.quotationSubmitter || [],
                  function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: {
                        label:
                          item.name +
                          (item.status_cn && item.status_cn !== "在职"
                            ? "（" + item.status_cn + "）"
                            : ""),
                        value: item.id,
                      },
                    })
                  }
                ),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "提交时间" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "230px" },
                attrs: {
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "value-format": "yyyy-MM-dd",
                  format: "yyyy-MM-dd",
                },
                on: { change: _vm.changeQuotationCreatedTime },
                model: {
                  value: _vm.quotationCreatedAtTime,
                  callback: function ($$v) {
                    _vm.quotationCreatedAtTime = $$v
                  },
                  expression: "quotationCreatedAtTime",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.quotationResetList },
                },
                [_vm._v("搜 索")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tabActiveName == "6",
              expression: "tabActiveName == '6'",
            },
          ],
          attrs: {
            border: "",
            "header-cell-style": { background: "#f1f1f1", color: "#333333" },
            align: "center",
            data: _vm.quotationListData,
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "任务ID/项目状态", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.number))]),
                    _c("div", [_vm._v(_vm._s(scope.row.status_cn))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "客户名称/项目名称" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(scope.row.customer_name) +
                          "(" +
                          _vm._s(scope.row.customer_id) +
                          ")"
                      ),
                    ]),
                    _c("div", [_vm._v(_vm._s(scope.row.project_name))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "项目类型/任务", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.project_type_cn))]),
                    _vm._l(scope.row.type_of_demand, function (value, index) {
                      return _c("div", { key: index }, [
                        _c("span", [_vm._v(_vm._s(value.type_cn))]),
                        _vm._v(" （ "),
                        _c(
                          "span",
                          {
                            style: {
                              color:
                                {
                                  1: "#409EFF",
                                  50: "#E6A23C",
                                  100: "#F56C6C",
                                  200: "#409EFF",
                                  201: "#409EFF",
                                  300: "#909399",
                                  400: "#F56C6C",
                                  800: "#909399",
                                }[value.status] || "#409EFF",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                {
                                  1: "待审批",
                                  50: "待分配",
                                  100: "处理中",
                                  200: "待验收",
                                  201: "设计完成待确认",
                                  300: "已完成",
                                  400: "审批驳回",
                                  450: "已开标未出结果",
                                  500: "未中标",
                                  550: "中标未交付",
                                  600: "中标已交付",
                                  800: "已失效",
                                }[value.status]
                              )
                            ),
                          ]
                        ),
                        _vm._v(" ） "),
                      ])
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "负责人", width: "110" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(scope.row.head, function (value, index) {
                    return _c("div", { key: index }, [
                      _vm._v(" " + _vm._s(value) + " "),
                    ])
                  })
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "提交人/提交时间", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.create_name))]),
                    _c("div", [_vm._v(_vm._s(scope.row.user_organize_name))]),
                    _c("div", [_vm._v(_vm._s(scope.row.created_at))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "处理人/处理时间", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.task_handler_name))]),
                    _c("div", [_vm._v(_vm._s(scope.row.task_handler_time))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "跟进记录", prop: "operation" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.operation && scope.row.operation.length > 9
                      ? _c(
                          "el-tooltip",
                          {
                            staticClass: "tipBox",
                            attrs: {
                              "popper-class": "popperTipBox",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              _vm._l(
                                scope.row.operation,
                                function (value, index) {
                                  return _c("div", { key: index }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(value.created_at) +
                                        " " +
                                        _vm._s(value.operation_id) +
                                        " " +
                                        _vm._s(value.content) +
                                        " "
                                    ),
                                  ])
                                }
                              ),
                              0
                            ),
                            _vm._l(
                              scope.row.operation,
                              function (value, index) {
                                return _c("div", { key: index }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(value.created_at) +
                                      " " +
                                      _vm._s(value.operation_id) +
                                      " " +
                                      _vm._s(value.content) +
                                      " "
                                  ),
                                ])
                              }
                            ),
                          ],
                          2
                        )
                      : _c(
                          "div",
                          _vm._l(scope.row.operation, function (value, index) {
                            return _c("div", { key: index }, [
                              _vm._v(
                                " " +
                                  _vm._s(value.created_at) +
                                  " " +
                                  _vm._s(value.operation_id) +
                                  " " +
                                  _vm._s(value.content) +
                                  " "
                              ),
                            ])
                          }),
                          0
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.viewDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    Number(scope.row.item_status) === 100
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              loading: _vm.cardRuleLoadingId === scope.row.id,
                              type: "text",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openCardRuleDrawer(scope.row)
                              },
                            },
                          },
                          [_vm._v("配置卡规则")]
                        )
                      : _vm._e(),
                    Number(scope.row.item_status) === 300
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              loading: _vm.cardRuleLoadingId === scope.row.id,
                              type: "text",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openCardRuleDrawer(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看卡规则")]
                        )
                      : _vm._e(),
                    _vm.$hasBtnRoles("/user/project-delivery/follow-up")
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openFollowUp(scope.row)
                              },
                            },
                          },
                          [_vm._v("跟进")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tabActiveName == "6",
              expression: "tabActiveName == '6'",
            },
          ],
          staticClass: "pages",
          staticStyle: { "text-align": "right", margin: "16px 0" },
        },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.quotationListPages.currentPage,
              "page-size": _vm.quotationSearchForm.pageSize,
              "page-sizes": [20, 50, 100, 200, 500],
              total: _vm.quotationListPages.totalCount,
              layout: "total,sizes, prev, pager, next, jumper",
            },
            on: {
              "current-change": _vm.handleQuotationPageChange,
              "size-change": _vm.quotationSizeChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tabActiveName == "5",
              expression: "tabActiveName == '5'",
            },
          ],
          attrs: {
            border: "",
            "header-cell-style": { background: "#f1f1f1", color: "#333333" },
            align: "center",
            data: _vm.ticketListData,
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "工单信息", width: "240" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v("ID：" + _vm._s(scope.row.work_order_no)),
                    ]),
                    _c("div", [_vm._v("标题：" + _vm._s(scope.row.title))]),
                    _c("div", [
                      _vm._v("提交时间：" + _vm._s(scope.row.created_at)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "咨询事项" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.category || "-"))]),
                    _c("div", [
                      _vm._v(_vm._s(scope.row.second_category || "-")),
                    ]),
                    _c("div", [_vm._v(_vm._s(scope.row.item || "-"))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "事项描述", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.description
                      ? _c("el-tooltip", { attrs: { placement: "top" } }, [
                          _c(
                            "div",
                            {
                              staticClass: "ticketDescTip",
                              attrs: { slot: "content" },
                              slot: "content",
                            },
                            [_vm._v(" " + _vm._s(scope.row.description) + " ")]
                          ),
                          _c("div", { staticClass: "ticketDescBox" }, [
                            _vm._v(_vm._s(scope.row.description)),
                          ]),
                        ])
                      : _c("span", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "当前处理人", width: "110" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          (scope.row.handler_list &&
                            scope.row.handler_list
                              .map(function (item) {
                                return item.handler_name
                              })
                              .join("、")) ||
                            "-"
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "处理结果", width: "90" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          { 10: "待分配", 20: "处理中", 30: "已解决" }[
                            scope.row.status
                          ] || "-"
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "跟进记录" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.operation && scope.row.operation.length > 9
                      ? _c(
                          "el-tooltip",
                          {
                            staticClass: "tipBox",
                            attrs: {
                              "popper-class": "popperTipBox",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              _vm._l(
                                scope.row.operation,
                                function (value, index) {
                                  return _c("div", { key: index }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(value.created_at) +
                                        " " +
                                        _vm._s(value.operation_id) +
                                        " " +
                                        _vm._s(value.content) +
                                        " "
                                    ),
                                  ])
                                }
                              ),
                              0
                            ),
                            _vm._l(
                              scope.row.operation,
                              function (value, index) {
                                return _c("div", { key: index }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(value.created_at) +
                                      " " +
                                      _vm._s(value.operation_id) +
                                      " " +
                                      _vm._s(value.content) +
                                      " "
                                  ),
                                ])
                              }
                            ),
                          ],
                          2
                        )
                      : _c(
                          "div",
                          _vm._l(scope.row.operation, function (value, index) {
                            return _c("div", { key: index }, [
                              _vm._v(
                                " " +
                                  _vm._s(value.created_at) +
                                  " " +
                                  _vm._s(value.operation_id) +
                                  " " +
                                  _vm._s(value.content) +
                                  " "
                              ),
                            ])
                          }),
                          0
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.viewTicketDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    Number(scope.row.status) === 20
                      ? [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.openTicketHandle(scope.row)
                                },
                              },
                            },
                            [_vm._v("处理")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.openTicketFollowUp(scope.row)
                                },
                              },
                            },
                            [_vm._v("跟进")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.openTicketAssign(scope.row)
                                },
                              },
                            },
                            [_vm._v("修改负责人")]
                          ),
                        ]
                      : Number(scope.row.status) === 30
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openTicketFollowUp(scope.row)
                              },
                            },
                          },
                          [_vm._v("跟进")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tabActiveName == "5",
              expression: "tabActiveName == '5'",
            },
          ],
          staticClass: "pages",
          staticStyle: { "text-align": "right", margin: "16px 0" },
        },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.ticketListPages.currentPage,
              "page-size": _vm.ticketSearchForm.pageSize,
              "page-sizes": [20, 50, 100, 200, 500],
              total: _vm.ticketListPages.totalCount,
              layout: "total,sizes, prev, pager, next, jumper",
            },
            on: {
              "current-change": _vm.handleTicketPageChange,
              "size-change": _vm.ticketSizeChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.applyFormVisible,
            "destroy-on-close": true,
            "append-to-body": "",
            "custom-class": "myFormDrawer",
            size: "88%",
            title: _vm.drawerTitle,
          },
          on: {
            "update:visible": function ($event) {
              _vm.applyFormVisible = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c("applyForm", {
            attrs: {
              visible: _vm.applyFormVisible,
              type: _vm.applyFormType,
              id: _vm.selectedId,
              projectType: _vm.selectedProjectType,
              projectStatus: _vm.selectedProjectStatus,
              fromTab: _vm.tabActiveName,
            },
            on: {
              "update:visible": function ($event) {
                _vm.applyFormVisible = $event
              },
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.cardRuleDrawerVisible,
            title: "通用配置",
            size: "87%",
            "custom-class": "myDrawer card-rule-drawer",
            "append-to-body": "",
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.cardRuleDrawerVisible = $event
            },
            close: _vm.handleCardRuleDrawerClose,
          },
        },
        [
          _vm.cardRuleDrawerVisible
            ? _c("cardCommonConfig", {
                attrs: {
                  trendParams: _vm.cardRuleTrendParams,
                  cardRuleKind: _vm.cardRuleKind,
                  deliveryAuthFree: true,
                },
                on: {
                  onSuccess: _vm.handleCardRuleSuccess,
                  deliverySaved: _vm.handleCardRuleSuccess,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("ticketHandleDialog", {
        ref: "ticketHandleDialog",
        attrs: { visible: _vm.ticketHandleVisible },
        on: {
          "update:visible": function ($event) {
            _vm.ticketHandleVisible = $event
          },
          success: _vm.handleTicketActionSuccess,
        },
      }),
      _c("ticketFollowUpDialog", {
        ref: "ticketFollowUpDialog",
        attrs: { visible: _vm.ticketFollowUpVisible },
        on: {
          "update:visible": function ($event) {
            _vm.ticketFollowUpVisible = $event
          },
          success: _vm.handleTicketActionSuccess,
        },
      }),
      _c("ticketAssignDialog", {
        ref: "ticketAssignDialog",
        attrs: {
          visible: _vm.ticketAssignVisible,
          title: "修改工单负责人",
          "success-message": "修改成功",
          mode: "modify",
        },
        on: {
          "update:visible": function ($event) {
            _vm.ticketAssignVisible = $event
          },
          success: _vm.handleTicketActionSuccess,
        },
      }),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.ticketDrawerVisible,
            "destroy-on-close": true,
            "append-to-body": "",
            "custom-class": "myFormDrawer",
            size: "88%",
            title: "工单详情",
          },
          on: {
            "update:visible": function ($event) {
              _vm.ticketDrawerVisible = $event
            },
          },
        },
        [
          _c("ticketForm", {
            attrs: {
              visible: _vm.ticketDrawerVisible,
              id: _vm.ticketFormId,
              type: _vm.ticketFormType,
              customerName: _vm.ticketFormCustomerName,
            },
            on: {
              "update:visible": function ($event) {
                _vm.ticketDrawerVisible = $event
              },
              success: _vm.handleTicketFormSuccess,
            },
          }),
        ],
        1
      ),
      _c("handleDialog", {
        ref: "handleDialog",
        on: { success: _vm.handleDialogSuccess },
      }),
      _c("FollowUpDialog", {
        attrs: {
          visible: _vm.followUpVisible,
          projectId: _vm.followUpProjectId,
          taskId: _vm.followUpTaskId,
        },
        on: {
          "update:visible": function ($event) {
            _vm.followUpVisible = $event
          },
          success: _vm.handleFollowUpSuccess,
        },
      }),
      _c("AddCardDialog", {
        ref: "addCardDialog",
        on: { success: _vm.handleAddCardSuccess },
      }),
      _c("BiddingStatusDialog", {
        ref: "biddingStatusDialog",
        on: { success: _vm.handleDialogSuccess },
      }),
      _c("PrintingStatusDialog", {
        ref: "printingStatusDialog",
        on: { success: _vm.handleDialogSuccess },
      }),
      _c("BiddingResultDialog", {
        ref: "biddingResultDialog",
        on: { success: _vm.handleDialogSuccess },
      }),
      _c("BiddingDeliveryDialog", {
        ref: "biddingDeliveryDialog",
        on: { success: _vm.handleDialogSuccess },
      }),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.printingRecordDrawer.visible,
            direction: "rtl",
            size: "88%",
            "destroy-on-close": "",
            "custom-class": "myDrawer",
            "append-to-body": true,
            title:
              _vm.printingRecordDrawer.params.type === "add"
                ? "添加印刷单"
                : "编辑印刷单",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.printingRecordDrawer, "visible", $event)
            },
            close: function ($event) {
              _vm.printingRecordDrawer.visible = false
            },
          },
        },
        [
          _vm.printingRecordDrawer.visible
            ? _c("CreatePrintingRecord", {
                attrs: { "drawer-params": _vm.printingRecordDrawer.params },
                on: {
                  close: function ($event) {
                    _vm.printingRecordDrawer.visible = false
                  },
                  success: _vm.handlePrintingRecordSuccess,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }